import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import RetryWorkflowStep from '@Application/WorkflowRuns/Retry/Commands/RetryWorkflowStep';
import retryWorkflowStep from '@Application/WorkflowRuns/Retry/retryWorkflowStep';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import useStrictCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useStrictCurrentFacility';
import * as React from 'react';
import { useDispatch } from '@verclam/synapse';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly subject: SubjectAddress;
	readonly preparationId: number;
	readonly stepRunId: number;
};

/** « Réessayer » on a document whose generation failed. Leaf action component: it dispatches itself. */
const RetryDocumentButton: React.FC<Props> = ({ subject, preparationId, stepRunId }) => {
	const dispatch = useDispatch();
	const { currentFacility } = useStrictCurrentFacility();
	const facilityId = currentFacility.id;
	const [isRetrying, setIsRetrying] = React.useState(false);

	const handleClick = React.useCallback(() => {
		setIsRetrying(true);
		dispatch(retryWorkflowStep(new RetryWorkflowStep(facilityId, subject, preparationId, stepRunId)))
			.catch(ignoreHandledError)
			.finally(() => {
				setIsRetrying(false);
			});
	}, [dispatch, facilityId, subject, preparationId, stepRunId]);

	return (
		<Button
			type="button"
			size="sm"
			severity="secondary"
			label="Réessayer"
			loading={isRetrying}
			onClick={handleClick}
		/>
	);
};

export default RetryDocumentButton;
